var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCabinBaggageIncluded = function SvgCabinBaggageIncluded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15C11 14.4477 10.5523 14 10 14C9.44772 14 9 14.4477 9 15V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C15 14.4477 14.5523 14 14 14C13.4477 14 13 14.4477 13 15V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.5V10.1765H17C18.6569 10.1765 20 11.5196 20 13.1765V19C20 20.6569 18.6569 22 17 22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22H9C9 22.5523 8.55228 23 8 23C7.44772 23 7 22.5523 7 22C5.34315 22 4 20.6569 4 19V13.1765C4 11.5196 5.34314 10.1765 7 10.1765H8V3.5C8 2.11929 9.11929 1 10.5 1H13.5C14.8807 1 16 2.11929 16 3.5ZM10 3.5C10 3.22386 10.2239 3 10.5 3H13.5C13.7761 3 14 3.22386 14 3.5V10.1765H10V3.5ZM6 13.1765C6 12.6242 6.44772 12.1765 7 12.1765H17C17.5523 12.1765 18 12.6242 18 13.1765V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V13.1765Z",
    fill: "#1D1D1D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 6,
    fill: "#44B50C",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9834 18.4403L16.0608 17.4095C15.8318 17.1537 15.4452 17.1378 15.1972 17.3738C14.9492 17.6099 14.9338 18.0086 15.1627 18.2644L16.5729 19.8399C16.8285 20.1254 17.2712 20.1067 17.5034 19.8007L20.3709 16.0194C20.5788 15.7453 20.5318 15.3492 20.2659 15.1348C20.0001 14.9204 19.616 14.9688 19.4081 15.243L16.9834 18.4403Z",
    fill: "white"
  })));
};
export default SvgCabinBaggageIncluded;